// Common functions that are used in the CisUpload component
// Customise here for different file templates

import { dateConversion } from '../../components/ReusableFunctions';
import { addonList, AppleCareAddons, oldAddonList, PPPaddons } from '../utils';

export const HUP_RQ_Code = 'ACCANS001722';
export const ACT_POSTPAID_RQ_Code = 'ACCANS001519';
export const ACT_PREPAID_RQ_Code = 'ACCANS001520';
export const NOT_SELECTED = 'Not Selected';
export const DFF_Text = 'DFF';

const DFF_RQ_Code = 'ACCANS003120';
// const CUSTOMER_OWN_PHONE_RQ_Code ="ACCANS001278"

export function readRQ(fileText) {
  // Handling Both RQ Upload Format
  const ContractInfoText = /Total:(.*?)Comments/i.exec(fileText)?.[1] || '';

  let DFF = '';
  let rqImei = '';
  if (fileText?.includes(DFF_RQ_Code)) {
    DFF = DFF_Text;
    rqImei = DFF_Text;
  } else {
    rqImei = ContractInfoText.match(/\b\d{15}\b/)?.[0] || '';
  }

  const timePattern = /\b(0?[1-9]|1[0-2]):[0-5][0-9]\s?[APap][Mm]\b/g;
  const times = fileText?.match(timePattern);

  let salesPerson = /Sales Person: ([\w\s]+)/.exec(fileText)?.[1].trim();
  if (salesPerson === 'Tendered By') {
    // go for second format of RQ
    salesPerson = /Thanks for your Business! ([\w\s]+) Sales Person: Tendered By:/
      .exec(fileText)?.[1]
      .trim();
  }

  let accountNum = /(DBA|DBC|DBB)\d{11}/i.exec(ContractInfoText)?.[0] || '';
  if (DFF && !accountNum) {
    const accountNumMatch = /Account\s#:\s(.*?)(?:\s|$)/.exec(fileText);
    if (accountNumMatch) {
      accountNum = /(DBA|DBC|DBB)\d{11}/i.exec(accountNumMatch)?.[0] || '';
    }
  }

  
  let values = {
    storeInvoice: /Sale\sInvoice(.*?)Tendered\sOn/i.exec(fileText)?.[1].trim().slice(2, 9).trim(),
    saleInvoice: /Sale Invoice : ([A-Z0-9]+)/i.exec(fileText)?.[1] || 'N/A',
    tenderedDate: dateConversion(/\d{2}-[A-Za-z]{3}-\d{4}/.exec(fileText)?.[0]),
    time: times?.[0],
    imei: rqImei,
    // This is phone number
    simNumber: DFF ? DFF : ContractInfoText.match(/\b\d{10}\b/g)?.[0] || '',
    accountNum,
    salesPerson,
  };

  return values;
}

export function readCIS(fileText) {
  if (!fileText) return {};

  const addonsText = /Optional\sPaid\sAdd-Ons\sInternational\s(.*?)Nationwide/i
    .exec(fileText)?.[1]
    ?.trim();
  const DFF = fileText.includes('To be confirmed upon Service activation') ? DFF_Text : '';

  const PPP = PPPaddons.find((addon) => addonsText?.includes(addon)) || NOT_SELECTED;
  const appleCare = AppleCareAddons.find((addon) => addonsText?.includes(addon)) || NOT_SELECTED;
  const addons = addonList.find((addon) => addonsText?.includes(addon)) || '';
  const addonArray = addonsText
    ? [...addonList, ...oldAddonList].filter((addon) => addonsText.includes(addon))
    : [];
  const InitialCredit = /Initial\sCredit\sLimit\s\$(.*?)\s/i.exec(fileText);

  const commitmentPeriodMatch = /Commitment\sPeriod\s(\d+\s*Month(?:s)?)/.exec(fileText);
  const commitmentPeriod = commitmentPeriodMatch ? commitmentPeriodMatch[1] : '';

  const commitmentEndDateMatch = /Commitment\sEnd\sDate\s\^\s(\w+\s+\d{2},\s+\d{4})/.exec(fileText);
  const commitmentEndDate = commitmentEndDateMatch ? commitmentEndDateMatch[1] : '';

  const agreementStartDateMatch = /Agreement\sStart\sDate\s(\w+\s+\d{2},\s+\d{4})/.exec(fileText);
  const agreementStartDate = agreementStartDateMatch ? agreementStartDateMatch[1] : '';

  const billingPeriodMatch = /Billing\s+Period\s+([\w\s,]+?)\s-\s(\w+\s+\d{2},\s+\d{4})\s/.exec(
    fileText,
  );
  const billingPeriod = billingPeriodMatch
    ? `${billingPeriodMatch[1].trim()} - ${billingPeriodMatch[2].trim()}`
    : '';

  const paymentDueMatch = /Payment\sDue\s(\w+\s+\d{2},\s+\d{4})/.exec(fileText);
  const paymentDue = paymentDueMatch ? paymentDueMatch[1] : '';

  const extendedWarrantyServices =
    /Extended\sWarranty\sServices\*\*\s(.*?)\s/.exec(fileText)?.[1] === 'Accepted';

  const totalMyTabSavingsMatch = /Total\sMyTab\sSavings\+\s(?:\$(\d+\.?\d*)|N\/A)/.exec(fileText);
  const totalMyTabSavings = totalMyTabSavingsMatch ? parseFloat(totalMyTabSavingsMatch[1]) || 0 : 0;

  const totalMyTabChargeMatch = /Total\sMyTab\sCharge\+\s(?:\$(\d+\.?\d*)|N\/A)/.exec(fileText);
  const totalMyTabCharge = totalMyTabChargeMatch ? parseFloat(totalMyTabChargeMatch[1]) || 0 : 0;

  const tradeUpReturnValueMatch = /TradeUp\sReturn\sValue\s(?:\$(\d+\.?\d*)|N\/A)/.exec(fileText);
  const tradeUpReturnValue = tradeUpReturnValueMatch
    ? parseFloat(tradeUpReturnValueMatch[1]) || 0
    : 0;

  const amountYouPaidMatch = /Amount\syou\spaid\sΔ\s(?:\$(\d+\.?\d*)|N\/A)/.exec(fileText);
  const amountYouPaid = amountYouPaidMatch ? parseFloat(amountYouPaidMatch[1]) || 0 : 0;

  const monthlyMyTabChargeMatch = /Monthly\sMyTab\sCharge\s(?:\$(\d+\.?\d*)|N\/A)/.exec(fileText);
  const monthlyMyTabCharge = monthlyMyTabChargeMatch
    ? parseFloat(monthlyMyTabChargeMatch[1]) || 0
    : 0;

  const myTabChargeMatch = /MyTab\sCharge\s(?:\$(\d+\.?\d*)|N\/A)/.exec(fileText);
  const myTabCharge = myTabChargeMatch ? parseFloat(myTabChargeMatch[1]) || 0 : 0;

  const monthlyMyTabSavingsMatch =
    /Monthly\sMyTab\sSavings\s(?:\$(\d+\.?\d*)\s\/\smonth|N\/A)/.exec(fileText);
  const monthlyMyTabSavings = monthlyMyTabSavingsMatch
    ? parseFloat(monthlyMyTabSavingsMatch[1]) || 0
    : 0;

  const totalMonthlyChargesMatch = /Total\sMonthly\sCharges:\s\$(\d+\.?\d*)\s\/\smonth/.exec(
    fileText,
  );
  const totalMonthlyCharges = totalMonthlyChargesMatch
    ? parseFloat(totalMonthlyChargesMatch[1])
    : 0;

  const timePattern = /\b(0?[1-9]|1[0-2]):[0-5][0-9]\s?[APap][Mm]\b/g;
  const times = fileText.match(timePattern);

  let values = {
    customerName: /Name(.*?)Commitment/i.exec(fileText)?.[1]?.trim(),
    accountNum: /Account\sNumber\s+(.*?)\s/.exec(fileText)?.[1]?.trim(),
    phoneNum: /Phone\sNumber\s(.*?)\s/.exec(fileText)?.[1]?.trim(),
    tempPhoneNum: /Temporary\sPhone\sNo.†(.*?)Deposit\sto\sbe/i.exec(fileText)?.[1]?.trim(),
    simNumber: DFF || /SIM\sNumber\s+(.*?)\s/.exec(fileText)?.[1]?.trim(),
    imei: DFF || /IMEI\s+(.*?)\s/.exec(fileText)?.[1]?.trim(),
    connectionType: /Type(.*?)Deposit/i.exec(fileText)?.[1]?.trim(),
    activationDate: dateConversion(
      /Agreement\sStart\sDate(.*?)Billing/i.exec(fileText)?.[1]?.trim(),
    ),
    phoneMake: /Model(.*?)(MyTab|Extended\sWarranty)/i.exec(fileText)?.[1]?.trim(),
    planName: /Plan\sName(.*?)Price/i.exec(fileText)?.[1]?.trim(),
    planPrice: /Charges\sRate\sPlan(.*?).00/i.exec(fileText)?.[1]?.trim(),
    oneTimeCharges: /non-refundable\sConnection\sFee\s.*?\$(\d+\.?\d*)\s/i
      .exec(fileText)?.[1]
      ?.trim(),
    addons: addons,
    storeId: /Store\sID(.*?)Specialist/i.exec(fileText)?.[1]?.trim(),
    specialistId: /Specialist\sID(.*?)Services/i.exec(fileText)?.[1]?.trim(),
    deposit: /Deposit(.*?)Deposit/i.exec(fileText)?.[1]?.trim().slice(2),
    retailPrice: /Retail\sPrice\s+(.*?)\s/i.exec(fileText)?.[1]?.trim(),
    activatedPromotion: /Activated\sPromotion(.*?)Rate\sPlan\sDetails/i
      .exec(fileText)?.[1]
      ?.trim()
      .slice(4),
    email: /Email\sAddress(.*?)Alternate\sPhone\sNumber/i.exec(fileText)?.[1]?.trim(),
    phoneProtectionPlan: PPP,
    appleCare: appleCare,
    initialCredit: InitialCredit ? `$${InitialCredit[1]}` : '',
    time: times?.[0],
    totalMyTabCharge,
    totalMyTabSavings,
    tradeUpReturnValue,
    amountYouPaid,
    monthlyMyTabCharge,
    myTabCharge,
    monthlyMyTabSavings,
    extendedWarrantyServices,
    totalMonthlyCharges,
    commitmentPeriod,
    commitmentEndDate,
    paymentDue,
    agreementStartDate,
    billingPeriod,
    addonArray,
  };

  return values;
}
